import React, { useEffect, useState } from 'react';
import { supabase } from '../supabaseClient';

const Terms = () => {
    const [pdfUrl, setPdfUrl] = useState('');
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchPdfUrl = async () => {
            try {
                const { data } = supabase.storage
                    .from('user contract')
                    .getPublicUrl('user_contract.pdf');

                if (data?.publicUrl) {
                    setPdfUrl(data.publicUrl);
                } else {
                    setError('Não foi possível carregar o documento.');
                }
            } catch (err) {
                setError('Erro ao carregar os termos de uso.');
                console.error(err);
            } finally {
                setLoading(false);
            }
        };

        fetchPdfUrl();
    }, []);

    if (loading) return <div className="terms-loading">Carregando...</div>;
    if (error) return <div className="terms-error">{error}</div>;

    return (
        <div className="terms-container">
            <nav className="terms-nav">
                <a href="/" className="back-button">← Voltar</a>
                <h1>Termos de Uso e Política de Privacidade</h1>
            </nav>
            <div className="pdf-viewer">
                <iframe
                    src={`${pdfUrl}#toolbar=0`}
                    title="Termos de Uso"
                    width="100%"
                    height="100%"
                    style={{ border: 'none' }}
                />
            </div>
        </div>
    );
};

export default Terms;
